import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
	selector: 'subscription-banner-list',
	template: require('./subscription-banner-list.html')
})
export class SubscriptionBannerListWebComponent implements OnInit, OnDestroy {
	constructor() {}

	ngOnInit() {}

	ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/subscription/subscription-elements/subscription-banner-list/subscription-banner-list.ts